import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../pages/Home.vue'
import Overview from '../pages/Overview.vue'
import Patent from '../pages/Patent.vue'
import Paper from '../pages/Paper.vue'
import RelationShip from '../pages/RelationShip.vue'

import { loadI18n } from '@/infrastructure/locales'

const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            path: '/',
            component: Home,
            redirect: '/overview',
            beforeEnter: async(to, from, next) => {
                await loadI18n();
                next();
            },
            children: [
                {
                    path: 'overview',
                    name: 'overview',
                    component: Overview,
                },
                {
                    path: 'patent',
                    name: 'patent',
                    component: Patent,
                },
                {
                    path: 'paper',
                    name: 'paper',
                    component: Paper,
                },
                {
                    path: 'relation-ship',
                    name: 'relation-ship',
                    component: RelationShip,
                }
            ],
        }

    ],
})

export default router
